/* eslint 'jsx-a11y/anchor-is-valid': 'off', eqeqeq: 'off'  */
import React, { Component } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import ASUInvoices from "./ASUInvoiceList";
import ASUMonthlyCharges from "./ASUMonthlyCharges"; 
import '../../../Assets/EnsembleStyles/EnsNav.css';
import { connect } from 'react-redux';
import { getUserPreferences } from '../../../action/cultureAction';


class ASUTab extends Component {
    componentWillMount() {
        this.props.getUserPreferences();
    }
    componentDidMount(){
        sessionStorage.setItem('WorkOrderSortingDetails', null);
        sessionStorage.setItem('WorkOrderFilterDetails', null);
        sessionStorage.setItem('PMSortingDetails', null);
        sessionStorage.setItem('PMFilterDetails', null);
    }
    constructor(props) {
        super(props);
        this.state = {
            activeTab: sessionStorage.getItem('activeContent') !== null ? parseInt(sessionStorage.getItem('activeContent')) : 1,
            activeContent: sessionStorage.getItem('activeContent') !== null ? parseInt(sessionStorage.getItem('activeContent')) : 1,
        };
        this.toggle = this.toggle.bind(this);
    }
    toggle(tab) {
        sessionStorage.setItem('activeContent',1);  
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab,
                activeContent: tab,
            });
        }
    }
    render(OnPremises) {
        let IsOnPremise = (this.props.OnPremises !== undefined && this.props.OnPremises !== null) ? this.props.OnPremises : false;
        

        let active_content = null, static_content = null;
        static_content =
            <div>
                {
                    IsOnPremise ? <span className="tab_title PageTitleBar" style={{ "paddingLeft": "12px", "display":"inline-block","margin-bottom":"15px"}}>Campus</span> : ""
                }
                {
                    
                         
                         <div className="row" style={{'margin-top':'10px'}}>
                            <div className="col-md-10" style={{"margin-top":"1px"}}>
                            <Nav tabs style={{'border-bottom':'0px'}}> 
                            
                                <NavItem>
                                    <NavLink className={classnames({ active: this.state.activeTab == '1' }, "WO_Tab_header_link", "link_cursor","header_tab")} onClick={() => { this.toggle('1'); }}> Invoices</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink className={classnames({ active: this.state.activeTab == '2' }, "WO_Tab_header_link", "link_cursor","header_tab")} onClick={() => { this.toggle('2'); }}> Monthly Charges</NavLink>
                                </NavItem>
                            </Nav>
                            </div>
                        </div>
                }
                
            </div>

        if (this.state.activeContent == 1) {
            active_content = <div>
                <TabContent activeTab="1" className="Tab_border">
                    <TabPane tabId="1"><ASUInvoices /></TabPane>
                </TabContent>
            </div>
        }
        else if (this.state.activeContent == 2) {
            active_content = <div>
                <TabContent activeTab="2" className="Tab_border">
                    <TabPane tabId="2"><ASUMonthlyCharges /></TabPane>
                </TabContent>
            </div>
        }
       
        return (
            <div style={{height:"100%"}} id="ASUScreens">
                {static_content}
                {active_content}
            </div>
        );
    }
};
const mapStateToProps = state => {
    return {
        OnPremises: state.authService.IsOnPremise
    };
};
const mapDispatchToProps = dispatch => {
    return {
        getUserPreferences: () => dispatch(getUserPreferences()),
       
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ASUTab);